import React, { useEffect } from 'react';
import { Box, Typography, CircularProgress } from '@mui/material';

const GoogleCallback: React.FC = () => {
    useEffect(() => {
        // Parse URL parameters
        const urlParams = new URLSearchParams(window.location.search);
        const code = urlParams.get('code');
        const error = urlParams.get('error');
        const state = urlParams.get('state');

        if (error) {
            // Send error to parent window
            window.opener?.postMessage({
                type: 'GOOGLE_SIGN_IN_ERROR',
                error: error
            }, window.location.origin);
        } else if (code) {
            // Send success with authorization code to parent window
            window.opener?.postMessage({
                type: 'GOOGLE_SIGN_IN_SUCCESS',
                code: code,
                state: state
            }, window.location.origin);
        } else {
            // No code or error - something went wrong
            window.opener?.postMessage({
                type: 'GOOGLE_SIGN_IN_ERROR',
                error: 'No authorization code received'
            }, window.location.origin);
        }

        // Close the popup
        window.close();
    }, []);

    return (
        <Box 
            display="flex" 
            flexDirection="column" 
            alignItems="center" 
            justifyContent="center" 
            height="100vh"
            gap={2}
        >
            <CircularProgress />
            <Typography variant="h6">Processing Google Sign-In...</Typography>
            <Typography color="text.secondary">This window will close automatically.</Typography>
        </Box>
    );
};

export default GoogleCallback;